export default [{
    "value": "CAP EXPANSION",
    "label": "CAP EXPANSION"
}, {
    "value": "CDW",
    "label": "CDW"
}, {
    "value": "CG01",
    "label": "CG01"
}, {
    "value": "CG02",
    "label": "CG02"
}, {
    "value": "CG03",
    "label": "CG03"
}, {
    "value": "CG04",
    "label": "CG04"
}, {
    "value": "CG05",
    "label": "CG05"
}, {
    "value": "CG06",
    "label": "CG06"
}, {
    "value": "CG07",
    "label": "CG07"
}, {
    "value": "CG61",
    "label": "CG61"
}, {
    "value": "CG64",
    "label": "CG64"
}, {
    "value": "CG68",
    "label": "CG68"
}, {
    "value": "DCAR",
    "label": "DCAR"
}, {
    "value": "FOREIGN RAILRD",
    "label": "FOREIGN RAILRD"
}, {
    "value": "GEO CAR",
    "label": "GEO CAR"
}, {
    "value": "MRL",
    "label": "MRL"
}, {
    "value": "MTCE",
    "label": "MTCE"
}, {
    "value": "PTC",
    "label": "PTC"
}, {
    "value": "RAIL GRINDER",
    "label": "RAIL GRINDER"
}, {
    "value": "RP01",
    "label": "RP01"
}, {
    "value": "RP03",
    "label": "RP03"
}, {
    "value": "RP04",
    "label": "RP04"
}, {
    "value": "RP05",
    "label": "RP05"
}, {
    "value": "RP06",
    "label": "RP06"
}, {
    "value": "RP07",
    "label": "RP07"
}, {
    "value": "RP08",
    "label": "RP08"
}, {
    "value": "RP08",
    "label": "RP08"
}, {
    "value": "RP08",
    "label": "RP08"
}, {
    "value": "RP09",
    "label": "RP09"
}, {
    "value": "RP10",
    "label": "RP10"
}, {
    "value": "RP11",
    "label": "RP11"
}, {
    "value": "RP12",
    "label": "RP12"
}, {
    "value": "RP13",
    "label": "RP13"
}, {
    "value": "RP14",
    "label": "RP14"
}, {
    "value": "RP15",
    "label": "RP15"
}, {
    "value": "RP16",
    "label": "RP16"
}, {
    "value": "RP17",
    "label": "RP17"
}, {
    "value": "RP18",
    "label": "RP18"
}, {
    "value": "RP19",
    "label": "RP19"
}, {
    "value": "RP20",
    "label": "RP20"
}, {
    "value": "RP21",
    "label": "RP21"
}, {
    "value": "RP22",
    "label": "RP22"
}, {
    "value": "RP23",
    "label": "RP23"
}, {
    "value": "SB29",
    "label": "SB29"
}, {
    "value": "SB30",
    "label": "SB30"
}, {
    "value": "SB31",
    "label": "SB31"
}, {
    "value": "SB32",
    "label": "SB32"
}, {
    "value": "SB33",
    "label": "SB33"
}, {
    "value": "SB34",
    "label": "SB34"
}, {
    "value": "SB35",
    "label": "SB35"
}, {
    "value": "SC29",
    "label": "SC29"
}, {
    "value": "SC30",
    "label": "SC30"
}, {
    "value": "SC31",
    "label": "SC31"
}, {
    "value": "SC32",
    "label": "SC32"
}, {
    "value": "SC33",
    "label": "SC33"
}, {
    "value": "SC34",
    "label": "SC34"
}, {
    "value": "SC35",
    "label": "SC35"
}, {
    "value": "SIG_CAP_X",
    "label": "SIG_CAP_X"
}, {
    "value": "SIG_CTC",
    "label": "SIG_CTC"
}, {
    "value": "SIG_WSDOT",
    "label": "SIG_WSDOT"
}, {
    "value": "Structures",
    "label": "Structures"
}, {
    "value": "SWITCH GRINDER",
    "label": "SWITCH GRINDER"
}, {
    "value": "TLU",
    "label": "TLU"
}, {
    "value": "TP01",
    "label": "TP01"
}, {
    "value": "TP02",
    "label": "TP02"
}, {
    "value": "TP03",
    "label": "TP03"
}, {
    "value": "TP05",
    "label": "TP05"
}, {
    "value": "TP06",
    "label": "TP06"
}, {
    "value": "TP07",
    "label": "TP07"
}, {
    "value": "TP08",
    "label": "TP08"
}, {
    "value": "TP09",
    "label": "TP09"
}, {
    "value": "TP10",
    "label": "TP10"
}, {
    "value": "TP11",
    "label": "TP11"
}, {
    "value": "TP41",
    "label": "TP41"
}, {
    "value": "TP42",
    "label": "TP42"
}, {
    "value": "TP43",
    "label": "TP43"
}, {
    "value": "TP44",
    "label": "TP44"
}, {
    "value": "TP45",
    "label": "TP45"
}, {
    "value": "TP46",
    "label": "TP46"
}, {
    "value": "TP47",
    "label": "TP47"
}, {
    "value": "TP48",
    "label": "TP48"
}, {
    "value": "TP49",
    "label": "TP49"
}, {
    "value": "TP56",
    "label": "TP56"
}, {
    "value": "TP60",
    "label": "TP60"
}, {
    "value": "TP61",
    "label": "TP61"
}, {
    "value": "TP63",
    "label": "TP63"
}, {
    "value": "TP64",
    "label": "TP64"
}, {
    "value": "TP68",
    "label": "TP68"
}, {
    "value": "TP69",
    "label": "TP69"
}, {
    "value": "UC01",
    "label": "UC01"
}, {
    "value": "UC02",
    "label": "UC02"
}, {
    "value": "UC03",
    "label": "UC03"
}, {
    "value": "UC04",
    "label": "UC04"
}, {
    "value": "UC05",
    "label": "UC05"
}, {
    "value": "UC06",
    "label": "UC06"
}, {
    "value": "UC07",
    "label": "UC07"
}, {
    "value": "UC08",
    "label": "UC08"
}, {
    "value": "UC09",
    "label": "UC09"
}, {
    "value": "UC10",
    "label": "UC10"
}, {
    "value": "WSDOT",
    "label": "WSDOT"
}];